import React from "react";
import { useNavigate } from "react-router-dom";

import SubHeader from "../../components/Header/SubmenuHeader";
import ResidentThumbnail from '../../assets/images/Resident-Thumbnail.png';

const HowToUse = () => {
  const navigate = useNavigate();
  
  const residentVideo = "https://tmw-storage.s3.ap-south-1.amazonaws.com/TMW-Kiosk/tmw_multimedia_assets/videos/Resident_compressed_.mp4";

  return (
    <>
      <SubHeader title={"HowToUse"} />

      {/* Main Section */}
      <section className="w-full max-w-[1920px] mx-auto bg-white px-4 sm:px-6 md:px-8 py-6">
        <div className="w-full max-w-[1211.62px] mx-auto flex flex-col">

          {/* Responsive Title Container – 35px above video */}
          <div className="mt-[35px] w-full flex justify-center">
            <div 
              className="
                w-[776px] h-[55px] flex items-center justify-center
                text-center capitalize
                text-[32px] sm:text-[36px] md:text-[40px]
                leading-[100%] tracking-[0%]
                font-alata font-normal
              "
            >
              How To Receive An Parcel?
            </div>
          </div>

          {/* Video */}
          <div className="mt-6 w-full">
            <video
              controls
              className="w-full max-h-[672.11px] object-cover rounded-lg shadow-lg"
              poster={ResidentThumbnail}
              preload="metadata"
            >
              <source src={residentVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

        </div>
      </section>
    </>
  );
};

export default HowToUse;
